"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageMain = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var __1 = require("..");
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var core_1 = require("../../../../shared/core");
var with_customer_and_account_ids_1 = require("../../../../shared/core/utils/with-customer-and-account-ids");
var analytics_subjects_1 = require("../../analytics-subjects");
var section_ids_1 = require("../../section-ids");
var utils_1 = require("../../utils");
var UsageContentWithData_1 = require("../UsageContent/UsageContentWithData");
var UsageTabs_1 = require("./UsageTabs");
var utils_2 = require("./utils");
var UsageMainUI = function (_a) {
    var accountId = _a.accountId, supplyPoints = _a.supplyPoints;
    var navigate = (0, ui_tools_1.useNavigate)();
    var search = window.location.search;
    var showTabs = (0, utils_2.shouldShowTabs)(supplyPoints);
    var _b = __read((0, react_1.useState)((0, utils_2.getDefaultDate)(search)), 2), date = _b[0], setDate = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), comparisonDate = _c[0], setComparisonDate = _c[1];
    var _d = __read((0, react_1.useState)('noComparison'), 2), compare = _d[0], setCompare = _d[1];
    var _e = __read((0, react_1.useState)((0, utils_2.getDefaultDatePeriod)(search, (0, utils_1.getSupplyInfo)(supplyPoints))), 2), datePeriod = _e[0], setDatePeriod = _e[1];
    var setCompareAndDate = function (comparison) {
        setCompare(comparison);
        switch (comparison) {
            case 'oneMonthEarlier':
                setComparisonDate((0, date_fns_1.subMonths)(date, 1));
                break;
            case 'sameMonthLastYear':
                setComparisonDate((0, date_fns_1.subYears)(date, 1));
                break;
            case 'previousYear':
                setComparisonDate((0, date_fns_1.subYears)(date, 1));
                break;
            case 'noComparison':
                setComparisonDate(null);
        }
    };
    var setDatePeriodAndUpdateQueryParams = function (datePeriod) {
        setDatePeriod(datePeriod);
        setCompareAndDate('noComparison');
        navigate({
            search: (0, utils_1.updatedQueryParams)('datePeriod', datePeriod, search),
        }, { replace: true });
    };
    var setDateAndUpdateQueryParams = function (date, datePeriod) {
        setDate(date);
        setCompareAndDate('noComparison');
        var updatedSearch = search;
        if (datePeriod) {
            setDatePeriod(datePeriod);
            updatedSearch = (0, utils_1.updatedQueryParams)('datePeriod', datePeriod, search);
            // Scroll to top of page, especially important when using the table links.
            window.scrollTo(0, 0);
        }
        navigate({
            search: (0, utils_1.updatedQueryParams)('date', (0, date_fns_1.format)(date, 'yyyy-MM-dd'), updatedSearch),
        }, { replace: true });
    };
    return (react_1.default.createElement(UsageTabs_1.UsageTabs, { datePeriod: datePeriod, setDatePeriod: setDatePeriodAndUpdateQueryParams, showTabs: showTabs },
        react_1.default.createElement(UsageContentWithData_1.UsageContentWithData, { accountId: accountId, date: date, setDate: setDateAndUpdateQueryParams, compare: compare, setCompare: setCompareAndDate, comparisonDate: comparisonDate || undefined, datePeriod: datePeriod, supplyPoints: supplyPoints })));
};
var Loading = function () {
    var Card = (0, core_1.useComponents)().Card;
    return (react_1.default.createElement(Card, null,
        react_1.default.createElement(__1.Loading, null)));
};
var Error = function () {
    var _a = (0, core_1.useComponents)(), Card = _a.Card, ErrorSection = _a.ErrorSection;
    return (react_1.default.createElement(Card, null,
        react_1.default.createElement(ErrorSection, { alertLevel: "error", id: section_ids_1.USAGE_ERROR, "data-testid": section_ids_1.USAGE_ERROR })));
};
exports.UsageMain = (0, with_customer_and_account_ids_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var accountId = _a.accountId;
    var _c = (0, legacy_queries_1.useSupplyPoints)(accountId), data = _c.data, loading = _c.loading, error = _c.error;
    if (error) {
        return react_1.default.createElement(Error, null);
    }
    if (loading || !data) {
        return react_1.default.createElement(Loading, null);
    }
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_1.USAGE_PAGE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(UsageMainUI, { accountId: accountId, supplyPoints: data })));
}, Loading);
